<template>
  <!-- 活动统计 -->
  <div class="activity">
    <!-- 统计图card -->
    <Card class="card" v-for="(chart,index) in chartsList" :key="chart.id">
      <!-- 统计图标题 -->
      <div slot="title" class="card-header">
        <div class="iconfont" :class="[chart.iconfont?chart.iconfont:'']"></div>
        {{chart.title}}
        <DatePicker
          type="daterange"
          split-panels
          :open="chart.open"
          confirm
          @on-change="dateChange"
          @on-ok="dateOk"
        >
          <!-- 时间选择 -->
          <div class="date-range" @click="openSelect(index)">
            {{chart.dateRange}}
            <Icon type="ios-arrow-down" :class="{rotateUp:chart.open}"/>
          </div>
        </DatePicker>
      </div>
      <!-- 统计图 扩展功能 -->
      <div slot="extra" class="card-extra" @click="exportChart(index)">
        <div class="extra-text">
          <span class="iconfont icon-daochu"></span>
          <span>导出</span>
        </div>
      </div>
      <!-- 统计图主体图表 -->
      <div class="card-body">
        <div :id="chart.chartId" class="chart-wrapper"></div>
      </div>
    </Card>
  </div>
</template>

<script>
  // 引入 ECharts 主模块
  var echarts = require("echarts/lib/echarts");
  // 引入柱状图
  require("echarts/lib/chart/bar");
  // 引入提示框和标题组件
  require("echarts/lib/component/tooltip");
  require("echarts/lib/component/title");
  require("echarts/lib/component/grid");
  require("echarts/lib/component/legendScroll");
  require("echarts/lib/component/dataZoom");
  export default {
    components: {},
    data() {
      return {
        activityNumber: null, // 活动数量实例
        applySignNumber: null, // 报名签到实例
        scoreRank: null, // 积分排名
        curIndex: -1, // 操作对象的索引
        chartsList: [
          {
            id: "activityNumber", // 用来匹配 echart 对象 匹配选择时间调用函数
            title: "活动数量统计",
            iconfont: "icon-shuju",
            chartId: "activityNumberChart",
            open: false, // 打开时间选择
            dateRange: "", // 选择的时间范围

            option: {
              title: {
                text: "活动数量",
                textStyle: {
                  color: "#999",
                  fontSize: "14"
                }
              },
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  // 坐标轴指示器，坐标轴触发有效
                  type: "line" // 默认为直线，可选为：'line' | 'shadow'
                }
              },
              grid: {
                left: "1%",
                right: "1%",
                top: '13%',
                bottom: "3%",
                containLabel: true
              },
              xAxis: [
                {
                  type: "category",
                  data: [],
                  axisTick: {
                    show: false,
                    alignWithLabel: true
                  },
                  splitLine: {
                    show: false
                  },
                  axisLabel: {
                    rotate: 0,
                    color: '#666'
                  },
                  axisLine: {
                    lineStyle: {
                      color: '#ddd'
                    }
                  }
                }
              ],
              yAxis: [
                {
                  type: "value",
                  splitLine: {
                    show: false
                  },
                  axisTick: {
                    show: false,
                  },
                  axisLabel: {
                    color: '#666'
                  },
                  axisLine: {
                    lineStyle: {
                      color: '#ddd'
                    }
                  }
                }
              ],
              dataZoom: [
                {
                  type: "inside",
                  xAxisIndex: [0]
                }
              ],
              series: [
                {
                  name: "活动数量",
                  type: "bar",
                  itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {offset: 0, color: "#828efc"},
                      {offset: 1, color: "#6be3f1"}
                    ])
                  },
                  barWidth: 20,
                  data: []
                }
              ]
            }
          },
          {
            id: "applySignNumber",
            title: "签到报名总数",
            iconfont: "icon-duibi",
            chartId: "applySignNumberChart",
            open: false, // 打开时间选择
            dateRange: "", // 选择的时间范围

            option: {
              legend: {
                textStyle: {
                  color: "#999",
                  fontSize: 14,
                  padding: [3, 0, 0, 0]
                },
                itemHeight: 16,
                // left:30,
                x: 'left',
                // data: [ "签到","报名"],
                icon: 'stack',
              },
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  // 坐标轴指示器，坐标轴触发有效
                  type: "line" // 默认为直线，可选为：'line' | 'shadow'
                }
              },
              grid: {
                left: "1%",
                right: "1%",
                top: '13%',
                bottom: "3%",
                containLabel: true
              },
              xAxis: [
                {
                  type: "category",
                  data: [],
                  axisTick: {
                    show: false,
                    alignWithLabel: true
                  },
                  splitLine: {
                    show: false
                  },
                  axisLabel: {
                    rotate: 0,
                    color: '#666'
                  },
                  axisLine: {
                    lineStyle: {
                      color: '#ddd'
                    }
                  }
                }
              ],
              yAxis: [
                {
                  type: "value",
                  splitLine: {
                    show: false
                  },
                  axisTick: {
                    show: false,
                  },
                  axisLabel: {
                    color: '#666'
                  },
                  axisLine: {
                    lineStyle: {
                      color: '#ddd'
                    }
                  }
                }
              ],
              dataZoom: [
                {
                  type: "inside",
                  xAxisIndex: [0]
                }
              ],
              series: [
                {
                  name: "签到",
                  type: "bar",
                  itemStyle: {
                    color: '#7894de'
                  },
                  barWidth: 15,
                  data: []
                }, {
                  name: "报名",
                  type: "bar",
                  itemStyle: {
                    color: '#89e7b5'
                  },
                  barWidth: 15,
                  barGap: '66%',
                  data: []
                }
              ],
            }
          },
          {
            id: "scoreRank",
            title: "活动积分排名",
            iconfont: "icon-paiming",
            chartId: "scoreRankChart",
            open: false, // 打开时间选择
            dateRange: "", // 选择的时间范围

            option: {
              title: {
                text: "活动积分",
                textStyle: {
                  color: "#999",
                  fontSize: "14"
                }
              },
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  // 坐标轴指示器，坐标轴触发有效
                  type: "line" // 默认为直线，可选为：'line' | 'shadow'
                }
              },
              grid: {
                left: "1%",
                right: "1%",
                top: '13%',
                bottom: "3%",
                containLabel: true
              },
              xAxis: [
                {
                  type: "category",
                  data: [],
                  axisTick: {
                    show: false,
                    alignWithLabel: true
                  },
                  splitLine: {
                    show: false
                  },
                  axisLabel: {
                    rotate: 0,
                    color: '#666'
                  },
                  axisLine: {
                    lineStyle: {
                      color: '#ddd'
                    }
                  }
                }
              ],
              yAxis: [
                {
                  type: "value",
                  splitLine: {
                    show: false
                  },
                  axisTick: {
                    show: false,
                  },
                  axisLabel: {
                    color: '#666'
                  },
                  axisLine: {
                    lineStyle: {
                      color: '#ddd'
                    }
                  }
                }
              ],
              dataZoom: [
                {
                  type: "inside",
                  xAxisIndex: [0]
                }
              ],
              series: [
                {
                  name: "积分数量",
                  type: "bar",
                  barWidth: 20,
                  itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {offset: 0, color: "#fee69e"},
                      {offset: 1, color: "#ff8033"}
                    ])
                  },
                  data: []
                }
              ]
            }
          }
        ]
      };
    },
    computed: {
      /* 时间返回选择器的初始时间 */
      initDate() {
        let now = Date.now();
        let beginDate = now - 7 * 24 * 60 * 60 * 1000;
        //let endDate = now + 7 * 24 * 60 * 60 * 1000;
        // return (
        //   this.$util.FormatDate(beginDate, "yyyy-MM-dd") +
        //   "到" +
        //   this.$util.FormatDate(endDate, "yyyy-MM-dd")
        // );
        let endDate = now;
        return (
          "2019-01-01 至 " +
          this.$util.FormatDate(endDate, "yyyy-MM-dd")
        );
      }
    },
    created() {
      this.getActivityCount(this.initDate.split(" 至 ")); // 默认查询初始时间
      this.getActivitySignCount(this.initDate.split(" 至 ")); // 报名签到
      this.getScoreRank(this.initDate.split(" 至 ")); // 积分排名
    },
    mounted() {
      // 如果没有初始化 实例时 初始化 因为必须依赖dom 所以放到 mounted
      if (!this.activityNumber) {
        this.initCharts(); // 初始化 echart 实例
      }
    },
    methods: {
      // 获取活动数量
      getActivityCount(data) {
        console.log(data)
        let url = this.urlobj.activityCount;

        let [beginDate, endDate] = data; // 获取 时间段
        this.$get(url, {
          beginDate,
          endDate
        })
          .then(res => {
            if (res.isSucceed) {
              let _option = this.chartsList[0].option; // 获取当前options
              let _res = res.rows[0]; // 返回对象
              _option.xAxis[0].data = _res.xaxis; // X轴名称
              // _option.xAxis[0].data = new Array(20).fill(_res.xaxis[0]);

              _option.series[0].data = _res.series.map(item => item.data[0]); // x轴数据
              // _option.series[0].data = new Array(20).fill(20);
              // 是否倾斜x轴名称 大于10个开始倾斜
              if (_option.xAxis[0].data.length > 10)
                _option.xAxis[0].axisLabel.rotate = -30;

              this.activityNumber.setOption(_option);
            }
          })
          .catch(e => {
            console.log(e);
          });
      },
      // 获取签到报名人数
      getActivitySignCount(data) {
        let url = this.urlobj.activitySignCount;

        let [beginDate, endDate] = data; // 获取 时间段
        this.$get(url, {
          beginDate,
          endDate
        })
          .then(res => {
            if (res.isSucceed) {
              let _option = this.chartsList[1].option; // 获取当前options
              let _res = res.rows[0]; // 返回对象

              _option.legend.data = _res.legend.reverse(); // 获取 图例
              // 初始化数据名称 与图例名称一致
              _option.series.forEach((item, index) => {
                item.name = _option.legend.data[index];
              });
              // 初始化 X 轴
              _option.xAxis[0].data = _res.xaxis;
              // _option.xAxis[0].data = new Array(20).fill('12');
              // 是否倾斜x轴名称 大于10个开始倾斜
              if (_option.xAxis[0].data.length > 10)
                _option.xAxis[0].axisLabel.rotate = -30;
              // 初始化X轴 数据
              // _res.series.reverse()
              _option.series.forEach((optItem, index) => {
                optItem.data = _res.series
                  .filter(resItem => optItem.name == resItem.name)
                  .map(item => item.data[0]);
              });
              // 重设置options
              this.applySignNumber.setOption(_option);
            }
          })
          .catch(e => {
            console.log(e);
          });
      },
      // 积分排名
      getScoreRank(data) {
        let url = this.urlobj.scoreRank;
        let [beginDate, endDate] = data; // 获取 时间段
        this.$get(url, {
          beginDate,
          endDate
        })
          .then(res => {
            if (res.isSucceed) {
              let _option = this.chartsList[2].option; // 获取当前options
              let _res = res.rows[0]; // 返回对象

              _option.xAxis[0].data = _res.xaxis;
              // _option.xAxis[0].data = new Array(20).fill('12');
              // 是否倾斜x轴名称 大于10个开始倾斜
              if (_option.xAxis[0].data.length > 10)
                _option.xAxis[0].axisLabel.rotate = -30;

              _option.series[0].data = _res.series.map(item => item.data[0]);
              // 重设置options
              this.scoreRank.setOption(_option);
            }
          })
          .catch(e => {
            console.log(e);
          });
      },
      /* 初始化 charts */
      initCharts() {
        for (const chart of this.chartsList) {
          /* 初始化echart对象 */
          let _tmp = echarts.init(document.getElementById(chart.chartId));
          /* 初始化 option */
          _tmp.setOption(chart.option);
          /* 初始化页面 echart 对象 */
          this[chart.id] = _tmp;
          /* 初始化时间初始值 */
          chart.dateRange = this.initDate;
        }
      },
      /* 时间选择 */
      dateChange(timeArr) {
        /* 这个判断 由于iview 返回的数据格式问题  */
        if (timeArr[0]) {
          this.chartsList[this.curIndex].dateRange =
            timeArr[0] + " 至 " + timeArr[1];
        } else {
          this.chartsList[this.curIndex].dateRange = this.initDate;
        }
      },
      /* 时间选择确认 */
      dateOk() {
        let _curObj = this.chartsList[this.curIndex];
        /* 1. 关闭现在的时间选择器 */
        _curObj.open = false;
        /* 2. 确认时间范围 发送新的数据请求 */
        switch (_curObj.id) {
          case "activityNumber":
            this.getActivityCount(_curObj.dateRange.split(" 至 "));
            break;
          case "applySignNumber":
            this.getActivitySignCount(_curObj.dateRange.split(" 至 "));
            break;
          case "scoreRank":
            this.getScoreRank(_curObj.dateRange.split(" 至 "));
            break;
        }
      },
      /* 点击打开时间选择 */
      openSelect(index) {
        this.curIndex = index;
        let _cur = this.chartsList[this.curIndex];
        /* 关闭页面中所有展开的非向前操作对象的时间选择器 */
        for (const chart of this.chartsList) {
          if (chart.id != _cur.id && chart.open) {
            chart.open = false;
          }
        }
        /* 操作所选择的时间选择器 */
        _cur.open = !_cur.open;
      },
      /* 导出表格 */
      exportChart(index) {
        let _curObj = this.chartsList[index];
        // 判断没有数据 不导出
        if (this._.isEmpty(_curObj.option.xAxis[0].data)) {
          this.$Message.info("暂无数据导出");
          return;
        }
        let [beginDate, endDate] = _curObj.dateRange.split(" 至 ");
        let data = {
          beginDate,
          endDate,
          communityId: this.$store.state.streetorcommunityid
        };
        /* 2. 确认时间范围 发送新的数据请求 */
        switch (_curObj.id) {
          case "activityNumber":
            window.open(
              this.$util.concatUrl(this.urlobj.activityCountExport, data)
            );
            break;
          case "applySignNumber":
            window.open(
              this.$util.concatUrl(this.urlobj.applySignCountExport, data)
            );
            break;
          case "scoreRank":
            window.open(
              this.$util.concatUrl(this.urlobj.activityScoreExport, data)
            );
            break;
        }
      }
    }
  };
</script>

<style lang="less" scoped>
  /* 活动图表开始 */
  .activity .card {
    width: 100%;
    margin-bottom: 20px;
  }

  /* 标题 */
  .card-header {
    display: flex;
    align-items: center;
    height: 24px;
    line-height: 24px;
    .iconfont {
      color: #ff7d44;
      margin-right: 10px;
    }
  }

  /* 扩展 */
  .extra-text {
    font-size: 14px;
    color: #67799d;
    cursor: pointer;
  }

  .extra-text .icon-daochu {
    margin-right: 2px;
  }

  /* chart */
  .chart-wrapper {
    width: 100%;
    height: 330px;
  }

  .date-range {
    cursor: pointer;
    margin-left: 20px;
    color: #999;
    .ivu-icon {
      transition: all 300ms cubic-bezier(0.075, 0.82, 0.165, 1);
    }
  }

  /* 箭头旋转向上 */
  .rotateUp {
    transform: rotateZ(-180deg);
  }
</style>

